import { _axios } from "../axios";
import { AxiosResponse } from "axios";

/**
 * Gets all departments for a given product
 * @param productSlug
 * @returns {AxiosResponse<any>}
 */
export function getProductDepartments( productSlug = '' ) {
    return _axios.get('/products/' + productSlug + '/departments');
}

/**
 *
 * @param productSlug
 * @param departments
 * @returns {AxiosResponse<any>}
 */
export function storeProductDepartments( productSlug = '', departments = {}) {
    return _axios.post('/products/' + productSlug + '/departments', {'departments' : departments });
}